import React from 'react';

import { FlexTable, FlexTableColumn } from '@uplift/ui-v2';
import { Paper } from '@mui/material';
import { l10nEnService } from '@uplift/services';
import { UnsubmittedSessionRow } from '../../types';
import { ContentStack } from './content-stack.component';
import { ActionCell, DateTimeCell, DetailsCell } from './cells';

export type UnsubmittedSessionsTableProps = {
  rows: UnsubmittedSessionRow[];
};

export const unsubmittedSessionsTableColumns = [
  {
    field: 'fromDatetime',
    headerName: l10nEnService.calendar.date,
    renderCell: params => <DateTimeCell {...params} />,
  } as FlexTableColumn<UnsubmittedSessionRow, 'fromDatetime'>,
  {
    field: 'patientName',
    headerName: l10nEnService.general.client,
    renderCell: ({ value: patientName }) => <ContentStack primary={patientName} />,
  } as FlexTableColumn<UnsubmittedSessionRow, 'patientName'>,
  {
    field: '',
    headerName: l10nEnService.general.details,
    renderCell: ({ row: { appointmentType } }) => <DetailsCell appointmentType={appointmentType} />,
  } as FlexTableColumn<UnsubmittedSessionRow, null>,
  {
    field: 'appointmentId',
    headerName: ' ',
    renderCell: params => <ActionCell {...params} />,
    width: 256
  } as FlexTableColumn<UnsubmittedSessionRow, 'appointmentId'>,
];

export const UnsubmittedSessionsTable: React.FC<UnsubmittedSessionsTableProps> = (props) => {
  return (
    <Paper elevation={1}>
      <FlexTable
        rows={props.rows}
        columns={unsubmittedSessionsTableColumns}
        pinColumn="end"
      />
    </Paper>
  );
};
